// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"154":"7a2c07fe2246245a","231":"955c08a977f016af","651":"ee1f4b0b4c53aa6f","741":"6095d10ffbaef248"}[chunkId] + ".js";
};